import { Table } from "antd";

const MileStoneTable = ({ columnsData, tableData }) => {
    const columns = [
            {
                    title: 'Unit No.',
                    dataIndex: 'unit',
                    key: 'unit',
                    fixed: 'left',
                    align: 'center',
                    width: 350,
            },
            ...columnsData?.map((milestone) => ({
                    title: milestone.title,
                    children: milestone.children.map((child) => ({
                            title: child.label,
                            dataIndex: child.dataIndex,
                            key: child.dataIndex,
                            align: 'center',
                            onCell: () => ({
                                    style: { background: '#F5F5F5', fontWeight: '500' },
                            }),
                    })),
            })),
    ];

    return (
            <Table
                    columns={columns}
                    dataSource={tableData}
                    pagination={false}
                    bordered
                    className={` custom-ant-table`}
                    scroll={{ x: 'max-content' }}
            />
    );
};
export default MileStoneTable;
